import BaseTimeSlots from 'reservations/availabilities/components/BaseTimeSlots';
import type { Slot } from 'reservations/availabilities/types';

type AllTimeSlotsProps = {
  slots: (Slot | null)[];
  name: string;
  handleSlotClick: (_timeSlot: string) => void;
};

function AllTimeSlots({ slots, name, handleSlotClick }: AllTimeSlotsProps) {
  return (
    <BaseTimeSlots
      slots={slots}
      name={name}
      handleSlotClick={handleSlotClick}
    />
  );
}

export default AllTimeSlots;
